import { z } from 'zod'
import { REASONING_VALUES } from './REASONING_VALUES'

export const ReasoningInputSchema = z.enum(
  ['No selection', 'Based on evidence', 'Based on program rules', 'Other'],
  {
    errorMap: () => ({ message: 'Please select a valid reasoning.' }),
  }
)

export type ReasoningInput = z.infer<typeof ReasoningInputSchema>

export const ReasoningSchema = ReasoningInputSchema.transform((val) => {
  return REASONING_VALUES[val]
})
